import type { ReactNode } from 'react';
import { cn } from '../../lib/utils.js';

/**
 * Horizontal-scroll container for raw `<table>`s. Several list pages wrapped
 * their tables in `overflow-hidden` cards, which CLIPPED columns on narrow
 * viewports; this is the drop-in replacement (keep the card border/rounding
 * via `className`). Wide tables scroll sideways on phones instead of
 * overflowing or clipping.
 */
export function TableScroll({ className, children }: { className?: string; children: ReactNode }) {
  return <div className={cn('overflow-x-auto overscroll-x-contain', className)}>{children}</div>;
}
